import React from 'react';
import { Modal } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import ReportContentForm from './ReportContentForm';
import { useDispatch } from 'react-redux';
import { flaggedContent } from '../../CircleCommunityPage.duck';
import css from './ReportContentModal.module.css';
import { createTicketEventIDs, reported_posts } from '../../../../util/types';
import { onCreateIntercomTicket } from '../../../../util/api';
const ReportContentModal = props => {

  const { isReportModal, onClickReportModal, currentUser } = props;
  const dispatch = useDispatch();

  const handleSubmitReport = values => {
    const {
      id: postId,
      space,
      author,
      body_plain_text
    } = isReportModal;
    const bodyParam = {
      flagged_content: {
        flagged_contentable_id: postId,
        flagged_contentable_type: 'Post',
        reported_reason_type: values?.reason,
        reported_reason_body: values?.explanation,
      },
    };

    // Add entry into intercom
    const userId = currentUser.id.uuid;
    const userEmail = currentUser.attributes.email;
    const {
      id,
      name
    } = space;
    const {
      // community_member_id: authorCommunityId="",
      name: authorName="",
      headline: authorId="",
    } = author;

    const intercomReportPostData = {
      userId,
      userEmail,
      spaceId: id + "",
      spaceName: name,
      postId: postId + "",
      reason: values?.reason || "",
      explanation: values?.explanation || "",
      // authorCommunityId: `${authorCommunityId ? authorCommunityId : ""}`,
      authorName: `${authorName ? authorName : ""}`,
      authorId: `${authorId ? authorId : ""}`,
      postContent:body_plain_text
    }
    const createTicketData = {
      ticketTypeId: createTicketEventIDs[reported_posts],
      attributes: intercomReportPostData,
      assignment: true
    };

    Promise.all([dispatch(flaggedContent(bodyParam)),onCreateIntercomTicket(createTicketData)])
  };

  return (
    <>
      {isReportModal ? <Modal
        id="reportContentModal"
        isOpen={isReportModal}
        onClose={onClickReportModal}
        onManageDisableScrolling={manageDisableScrolling}
        className={css.reportContentModal}
      >
        <div>
          <ReportContentForm onSubmit={handleSubmitReport} />
        </div>
      </Modal>: null}
    </>
  );
};

export default ReportContentModal;
